import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const ThFlagIcon = ({ size = 34 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <g clipPath="url(#clip0_3961_24122)">
        <path
          d="M0 11.5687V13.0283V13.5923V15.4307V16.8902V18.3541V20.4078V21.1095V23.202H34V21.1095V20.4078V18.3541V15.6029V13.5923V12.8474V10.8454H0V11.5687Z"
          fill="#000DB4"
        />
        <path
          d="M0 4.67139V5.33012V7.68519V9.14473V10.8454H34V10.0962V7.34075V4.67139H0Z"
          fill="#F9FAFA"
        />
        <path
          d="M34.0043 4.58961V4.32693C33.9931 3.18854 33.5367 2.09995 32.7331 1.29495C31.9295 0.48994 30.8428 0.0327181 29.7064 0.0215015H4.34935C3.29958 0.0185432 2.28458 0.398313 1.49376 1.08992C0.702941 1.78153 0.190322 2.73778 0.0515388 3.78019C0.0240803 3.9684 0.00970386 4.15827 0.00854492 4.34848V4.69294H34.0128L34.0043 4.58961Z"
          fill="#E10E00"
        />
        <path
          d="M0 23.865V26.6162V29.3717V29.3803H34V29.3717V26.6162V23.865V23.202H0V23.865Z"
          fill="#F9FAFA"
        />
        <path
          d="M0 29.6773C0.00340122 30.8238 0.459541 31.9225 1.26883 32.7332C2.07812 33.5439 3.17479 34.0009 4.3193 34.0043H29.6764C30.8172 33.9952 31.9083 33.5357 32.713 32.7256C33.5176 31.9155 33.9708 30.8201 33.9742 29.6773V29.3802H0V29.6773Z"
          fill="#E10E00"
        />
      </g>
      <defs>
        <clipPath id="clip0_3961_24122">
          <rect width="34" height="34" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

ThFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}

export default ThFlagIcon
